import React from "react";
import BaseComponent from "../../../../base/common/BaseComponent";
import ApproveProcedureFileManagement from "../fields/procedureFileManagementFields/approveProcedureFileManagement";
import styles from "../index.module.scss";
import ApproveSavedIn from "../fields/savedInFields/approvedSavedIn";
import ApproveClientServerPath from "../fields/serverPathFields/approveSeverPath";
import { dataStatus, savedInRadioValues } from "../../../publicDictionaryValues";

export default class ApproveProcedureFileSection extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      procedureFileTableState: {
        isTableBorderError: this.props.isTableBorderError,
        isChange: false,
      },
    };
  }

  handleReturnSectionTop = (isDisableAll: any) => {
    const {
      savedInReturnReasonInputValue,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
      isSavedInApproveBtnDisabled,
      isSavedInReturnBtnDisabled,
      initSavedInStatus,
      savedInReturnReasonLog,
    } = this.props.savedInProps;

    const {
      clientServerPathStatusName,
      clientServerPathStatusID,
      serverPathReturnReasonInputValue,
      isServerPathApproveBtnDisabled,
      isServerPathReturnBtnDisabled,
      clientServerPathReturnReason,
      serverPathReturnReasonLog,
      serverPathValue,
    } = this.props.serverPathProps;

    const { procedureSavedInRef, procedureServerPathRef } = this.props.refs;

    const { currentRole, isDisableAllActionButtons = false } = this.props.sectionProps;
    const isShow =
      savedInRadioValue !== savedInRadioValues.systemOnly && savedInRadioValue !== null;

    return (
      <div className={styles.fileSectionTop}>
        <ApproveSavedIn
          ref={procedureSavedInRef}
          savedInReturnReasonInputValue={savedInReturnReasonInputValue}
          procedureSaveInCategoryStatusID={procedureSaveInCategoryStatusID}
          isSavedInReturnBtnDisabled={isSavedInReturnBtnDisabled}
          isSavedInApproveBtnDisabled={isSavedInApproveBtnDisabled}
          isSavedInReturnReasonDisabled={
            savedInReturnReasonInputValue === null ||
            procedureSaveInCategoryStatusID === dataStatus.approval
          }
          savedInRadioValue={savedInRadioValue}
          initSavedInStatus={initSavedInStatus}
          savedInReturnReasonLog={savedInReturnReasonLog}
          isDisableAll={isDisableAll}
          isDisableAllActionButtons={isDisableAllActionButtons}
        />
        {/* {savedInRadioValue !== savedInRadioValues.systemOnly && ( */}
        <ApproveClientServerPath
          isShow={isShow}
          clientServerPathReturnReason={clientServerPathReturnReason}
          serverPathStatusID={clientServerPathStatusID}
          isServerPathReturnBtnDisabled={isServerPathReturnBtnDisabled}
          isServerPathApproveBtnDisabled={isServerPathApproveBtnDisabled}
          isServerPathReturnReasonDisabled={
            serverPathReturnReasonInputValue === null ||
            clientServerPathStatusID === dataStatus.approval
          }
          initServerPathStatus={this.props.initServerPathSectionState.clientServerPathStatusID}
          serverPathReturnReasonInputValue={serverPathReturnReasonInputValue}
          isServerPathReturned={clientServerPathStatusName === "Return"}
          currentRole={currentRole}
          ref={procedureServerPathRef}
          serverPathReturnReasonLog={serverPathReturnReasonLog}
          serverPathValue={serverPathValue}
          isDisableAll={isDisableAll}
          isDisableAllActionButtons={isDisableAllActionButtons}
        />
        {/* )} */}
      </div>
    );
  };

  render() {
    const { savedInRadioValue } = this.props.savedInProps;
    const {
      currentRole,
      isDisableAll,
      isDisableAllActionButtons = false,
    } = this.props.sectionProps;
    const {
      procedureRef,
      procedureFileTableRef,
      reasonRef,
      noteRef,
      procedureFileRef,
      procedureReplaceFileRef,
    } = this.props.refs;
    const isShow =
      savedInRadioValue !== savedInRadioValues.serverOnly && savedInRadioValue !== null;

    return (
      <div className={styles.fileSection}>
        <div className={styles.fileSectionTitle}>Procedure Files</div>

        {this.handleReturnSectionTop(isDisableAll)}

        <div
          className={`${styles.fileSectionTable} ${this.state.procedureFileTableState.isTableBorderError ? styles.border_error : ""}`}
          hidden={savedInRadioValue === savedInRadioValues.serverOnly}
        >
          {/* {savedInRadioValue !== savedInRadioValues.serverOnly && ( */}
          {/* @ts-ignore */}
          <ApproveProcedureFileManagement
            isShow={isShow}
            data={this.props.data}
            ref={procedureRef}
            procedureRef={procedureRef}
            fileTableRef={procedureFileTableRef}
            handleApprovedClick={(e: any) =>
              (this as any).handleProcedureFileTableApprovedClick(
                e.target.attributes.rowindex.value
              )
            }
            handleReturnClick={(e: any) =>
              (this as any).handleProcedureFileTableReturnClick(e.target.attributes.rowindex.value)
            }
            className="approveProcedureTable"
            pageType="approvePage"
            reasonRef={reasonRef}
            noteRef={noteRef}
            fileInputRef={procedureFileRef}
            tableReplaceFileInputRef={procedureReplaceFileRef}
            currentRole={currentRole}
            handleFileSelect={(e: any) => (this as any).handleReplaceFile(e, false)}
            handleReplaceFileSelect={(this as any).handleRowReplaceFileSelect}
            isShowExpendIcon={false}
            initProcedureTableData={[...this.props.initProcedureTableData]}
            isDisableAll={isDisableAll}
            isDisableAllActionButtons={isDisableAllActionButtons}
            isTableChange={this.state.procedureFileTableState.isChange}
            isTableBorderError={this.state.procedureFileTableState.isTableBorderError}
            isCopyPage={this.props.isCopyPage}
            isRejectCompletePage={this.props.isRejectCompletePage}
          />
          {/* )} */}
        </div>
      </div>
    );
  }
}
